export default __webpack_public_path__ + "static/shopify-hero-img-8644d253160a741c0f8957f0c4716fe9.png";